import { FormattedMessage } from 'react-intl';
import { useTheme } from 'styled-components';

import Button from '../../../../components/Button/Button';
import { InfoIcon } from '../../../../components/Icon/Icon';
import Tooltip from '../../../../components/Tooltip/Tooltip';
import { TransportTypeCustomersE } from '../../../../declarations/enums/common';
import { RoutesPathE } from '../../../../declarations/enums/routes';
import useReactRouter from '../../../../hooks/useReactRouter';
import {
  SectionTitleStyled,
  SingleButtonWrapperStyled,
  TitleWithTooltipWrapperStyled,
} from '../../HomePage.styled';
import {
  ImageStyled,
  ImageWrapperStyled,
  NoteStyled,
  WayajSubTitleStyled,
} from './SustainableActions.styled';

type SustainableActionsPropsT = {
  isWayajCustomer: boolean;
  isTransportType: boolean;
  customerId: string;
};

const SustainableActions: React.FC<SustainableActionsPropsT> = ({
  customerId,
  isWayajCustomer,
  isTransportType,
}) => {
  const { navigateTo } = useReactRouter();
  const { subHeaderColour } = useTheme();
  const isSLNCF = TransportTypeCustomersE.SAINT_LUCIA_NATIONAL_CONSERVATION_FUND === customerId;

  return (
    <>
      <div>
        <TitleWithTooltipWrapperStyled>
          <SectionTitleStyled level={3} align="center">
            <FormattedMessage
              id="button.exploreSustainableActions"
              defaultMessage="Explore Sustainable Actions"
            />
          </SectionTitleStyled>
          <Tooltip element={<InfoIcon />}>
            <FormattedMessage
              id="sustainableActions.tooltip.text"
              defaultMessage="By choosing this option, you can select to contribute just a Sustainable Action without having to purchase a Carbon Offset Project."
            />
          </Tooltip>
        </TitleWithTooltipWrapperStyled>

        {isWayajCustomer && (
          <WayajSubTitleStyled level={4} align="center" color={subHeaderColour}>
            <FormattedMessage
              id="home.sustainableActionsSection.subTitle"
              defaultMessage="Help Build a Brighter Future"
            />
          </WayajSubTitleStyled>
        )}

        <ImageWrapperStyled>
          <ImageStyled
            src={`/images/${isTransportType ? 'transportation-home-img-2' : 'SA-img-1'}.png`}
            alt="imageAlt"
          />
        </ImageWrapperStyled>

        <FormattedMessage
          id="home.sustainableActionsSection.text1"
          values={{
            p: (...chunks: string[]) => <p>{chunks}</p>,
            condition: isSLNCF && ' (SAs)',
          }}
        />

        <NoteStyled>
          <FormattedMessage
            id="home.sustainableActionsSection.noteText"
            defaultMessage="*Alignment with SDG's does not in any way indicate a project is endorsed by the United Nations."
          />
        </NoteStyled>
      </div>

      <SingleButtonWrapperStyled>
        <Button
          onClick={() => navigateTo(RoutesPathE.SUSTAINABLE_ACTIONS_PAGE)}
          isUpperCase={!isSLNCF}
        >
          {isTransportType ? (
            (isSLNCF && "Support Saint Lucia's SAs") || (
              <FormattedMessage
                id="sustainableActions.title"
                defaultMessage="Sustainable Actions"
              />
            )
          ) : (
            <FormattedMessage id="sustainableActions.title" defaultMessage="Sustainable Actions" />
          )}
        </Button>
      </SingleButtonWrapperStyled>
    </>
  );
};

export default SustainableActions;
